// src/pages/ChecksStripes/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "../CollectionPage";
import { getChecksStripes, PRODUCTS_PER_PAGE } from "../../data/checksStripes";

export default function ChecksStripes() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getChecksStripes()
      .then(setProducts)
      .catch(err => setError(err.message || "Failed to load products"));
  }, []);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>;
  }
  if (!products) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/checks-stripes",
    announcement: {
      headline: "Classic checks & stripes — timeless stationery is here!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Checks & Stripes",
      subtitle: "Classic patterns, beautifully bound",
     featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "The most elegant notebook on my desk — the pattern is crisp and the paper is incredible.",
      quoteLink: "#",
      rating: "4.6",
      ratingCount: "500+",
    },
  };

  return <CollectionPage config={config} />;
}